export default __webpack_public_path__ + "static/media/furniture5.bdb1be63.jpeg";